import { useState, useCallback, useMemo } from "react";
import { useListContext } from "ra-core";

export interface UseFilterSidebarReturn {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  activeFilterCount: number;
}

export const useFilterSidebar = (): UseFilterSidebarReturn => {
  const [open, setOpen] = useState(false);
  const { filterValues } = useListContext();

  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const activeFilterCount = useMemo(() => {
    return Object.entries(filterValues || {}).filter(
      ([key, value]) => key !== "q" && value !== undefined && value !== "",
    ).length;
  }, [filterValues]);

  return {
    open,
    setOpen,
    toggle,
    activeFilterCount,
  };
};
